<template>
  <v-dialog v-model="navigation.CRMWhatsappMediaCatalogMediaDialogIsVisible" :max-width="(input.CRMWhatsappMediaCatalogMediaFile == null || input.CRMWhatsappMediaCatalogMediaFileName == null || input.CRMWhatsappMediaCatalogMediaExtension == null || navigation.deleteCRMWhatsappMediaCatalogMedia) ? '40vw' : '65vw'" :persistent="navigation.insertCRMWhatsappMediaCatalogMedia || navigation.updateCRMWhatsappMediaCatalogMedia" @update:model-value="navigation.CRMWhatsappMediaCatalogMediaDialogIsVisible == false && closeCRMWhatsappMediaCatalogMediaDialog()">
    <v-card :max-width="(input.CRMWhatsappMediaCatalogMediaFile == null || input.CRMWhatsappMediaCatalogMediaFileName == null || input.CRMWhatsappMediaCatalogMediaExtension == null || navigation.deleteCRMWhatsappMediaCatalogMedia) ? '40vw' : '65vw'">
      <div v-if="loader.insertCRMWhatsappMediaCatalogMedia || loader.updateCRMWhatsappMediaCatalogMedia || loader.deleteCRMWhatsappMediaCatalogMedia" style="width: 100%; text-align: center; padding: 15px;">
        <v-progress-circular color="primary" indeterminate></v-progress-circular>
      </div>
      <div v-else>
        <div v-if="navigation.deleteCRMWhatsappMediaCatalogMedia">
          <v-alert type="error" variant="tonal" style="cursor: default; user-select: none;">
            <template v-slot:title>
              <h3>ATENCIÓN</h3>
            </template>
            <p style="margin-top: 5px;">El contenido multimedia <strong>{{ navigation.CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaName }}</strong> será eliminado</p>
            <p>Esta acción es irreversible</p>
            <v-checkbox v-model="input.deleteCRMWhatsappMediaCatalogMediaConfirmation" color="error" label="Estoy de acuerdo" hide-details></v-checkbox>
            <v-btn @click="deleteCRMWhatsappMediaCatalogMedia()" :disabled="!input.deleteCRMWhatsappMediaCatalogMediaConfirmation" color="error" dark block height="38" style="margin-top: 15px;">
              <h3>ELIMINAR CONTENIDO MULTIMEDIA</h3>
              <v-icon style="margin-left: 10px;" dark right>mdi-delete</v-icon>
            </v-btn>
            <v-btn @click="closeCRMWhatsappMediaCatalogMediaDialog()" color="primary" dark block height="38" style="margin-top: 15px;">
              <h3>CANCELAR</h3>
              <v-icon style="margin-left: 10px;" dark right>mdi-close-circle</v-icon>
            </v-btn>
          </v-alert>
        </div>
        <div v-else style="padding: 15px;">
          <div style="width: 100%; text-align: center; cursor: default; user-select: none;">
            <h2>{{ navigation.CRMWhatsappMediaCatalog.CRMWhatsappMediaCatalogName }}</h2>
          </div>
          <v-tooltip :disabled="systemInformation.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-switch 
                v-bind="props" 
                v-model="input.CRMWhatsappMediaCatalogMediaIsVisible" 
                color="primary" 
                :label="`El catálogo multimedia ${navigation.insertCRMWhatsappMediaCatalogMedia ? 'será' : 'es'} visible${navigation.insertCRMWhatsappMediaCatalogMedia ? ' desde su creación' : ''}`" 
                hide-details
                style="margin-bottom: 15px;"
              ></v-switch>
            </template>
            <span style="max-width: 400px; display: block;">La visibilidad del contenido multimedia determina si un contenido multimedia será o no visible desde otras partes de la aplicación que no sea la vista de catálogos multimedia</span>
          </v-tooltip>
          <div style="display: flex; gap: 3%;">
            <div ref="CRMWhatsappMediaCatalogMediaDialogInputContainer" :style="input.CRMWhatsappMediaCatalogMediaFile == null ? 'width: 100%' : 'width: 60%'">
              <v-tooltip :disabled="systemInformation.tooltipDisabled" open-delay="2000" location="top">
                <template v-slot:activator="{ props }">
                  <v-text-field 
                    v-bind="props"
                    ref="CRMWhatsappMediaCatalogMediaName"
                    v-model="input.CRMWhatsappMediaCatalogMediaName" 
                    :append-inner-icon="input.CRMWhatsappMediaCatalogMediaName && /\S/.test(input.CRMWhatsappMediaCatalogMediaName) ? 'mdi-alphabetical-variant-off' : 'mdi-alphabetical-variant'" 
                    @click:append-inner="input.CRMWhatsappMediaCatalogMediaName = null; this.$generalFunctions.default.blurInput(this, 'CRMWhatsappMediaCatalogMediaName');"
                    label="Nombre del contenido multimedia" 
                    variant="solo-filled" 
                    density="compact"
                    autocomplete="off"
                    hide-details
                    style="margin-bottom: 15px;"
                  ></v-text-field>
                </template>
                <span style="max-width: 400px; display: block;">El nombre del contenido multimedia. Se recomienda no repetir nombres para facilitar su diferenciación</span>
              </v-tooltip>
              <v-tooltip :disabled="systemInformation.tooltipDisabled" open-delay="2000" location="top">
                <template v-slot:activator="{ props }">
                  <v-textarea 
                    v-bind="props"
                    ref="CRMWhatsappMediaCatalogMediaDescription"
                    v-model="input.CRMWhatsappMediaCatalogMediaDescription" 
                    :append-inner-icon="input.CRMWhatsappMediaCatalogMediaDescription && /\S/.test(input.CRMWhatsappMediaCatalogMediaDescription) ? 'mdi-alphabetical-off' : 'mdi-alphabetical'" 
                    @click:append-inner="input.CRMWhatsappMediaCatalogMediaDescription = null; this.$generalFunctions.default.blurInput(this, 'CRMWhatsappMediaCatalogMediaDescription');"
                    label="Descripción del contenido multimedia (opcional)"
                    variant="solo-filled" 
                    density="compact"
                    rows="3"
                    max-rows="5"
                    auto-grow
                    autocomplete="off"
                    hide-details
                    style="margin-bottom: 15px;"
                  ></v-textarea>
                </template>
                <span style="max-width: 400px; display: block;">La descripción del contenido multimedia. Es un espacio opcional destinado a detallar el contenido o función del contenido multimedia</span>
              </v-tooltip>
              <v-tooltip :disabled="systemInformation.tooltipDisabled" open-delay="2000" location="top">
                <template v-slot:activator="{ props }">
                  <v-textarea 
                    v-bind="props"
                    ref="CRMWhatsappMediaCatalogMediaCaption"
                    v-model="input.CRMWhatsappMediaCatalogMediaCaption" 
                    :append-inner-icon="input.CRMWhatsappMediaCatalogMediaCaption && /\S/.test(input.CRMWhatsappMediaCatalogMediaCaption) ? 'mdi-clipboard-text-off' : 'mdi-clipboard-text'" 
                    @click:append-inner="input.CRMWhatsappMediaCatalogMediaCaption = null; this.$generalFunctions.default.blurInput(this, 'CRMWhatsappMediaCatalogMediaCaption');" 
                    label="Caption del contenido multimedia (opcional)" 
                    variant="solo-filled" 
                    density="compact"
                    rows="3"
                    max-rows="5"
                    auto-grow
                    autocomplete="off"
                    hide-details
                    style="margin-bottom: 15px;"
                  ></v-textarea>
                </template>
                <span style="max-width: 400px; display: block;">El caption del contenido multimedia. Es un espacio opcional que se envía junto con el contenido multimedia</span>
              </v-tooltip>
              <v-tooltip :disabled="systemInformation.tooltipDisabled" open-delay="2000" location="top">
                <template v-slot:activator="{ props }">
                  <v-text-field 
                    v-bind="props"
                    ref="CRMWhatsappMediaCatalogMediaFileName"
                    v-model="input.CRMWhatsappMediaCatalogMediaFileName" 
                    :append-inner-icon="input.CRMWhatsappMediaCatalogMediaFile == null ? 'mdi-folder' : 'mdi-folder-off'" 
                    @click="$refs.CRMWhatsappMediaCatalogMediaFileInput.click()"
                    @click:append-inner.stop="this.$generalFunctions.default.blurInput(this, 'CRMWhatsappMediaCatalogMediaFileName'); input.CRMWhatsappMediaCatalogMediaFile = null; input.CRMWhatsappMediaCatalogMediaFileName = null; input.CRMWhatsappMediaCatalogMediaExtension = null;" 
                    label="Archivo del contenido multimedia"
                    variant="solo-filled" 
                    density="compact"
                    readonly
                    hide-details
                    autocomplete="off"
                  ></v-text-field>
                  <input 
                    @change="CRMWhatsappMediaCatalogMediaFileUpload" 
                    ref="CRMWhatsappMediaCatalogMediaFileInput" 
                    accept="image/*, video/*, application/pdf"
                    type="file" 
                    style="display: none" 
                  />
                </template>
                <span style="max-width: 400px; display: block;">El archivo asociado al contenido multimedia. Se permiten archivos de tipo imagen, video y PDF</span>
              </v-tooltip>
            </div>
            <div v-if="input.CRMWhatsappMediaCatalogMediaFile != null && input.CRMWhatsappMediaCatalogMediaFileName != null && input.CRMWhatsappMediaCatalogMediaExtension != null" style="width: 40%; display: flex; align-items: start; justify-content: center;">
              <div v-if="input.CRMWhatsappMediaCatalogMediaExtension == 'webp'" :style="{ height: navigation.whatsappMediaCatalogMediaDialogInputContainerHeight + 'px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
                <img 
                  @click="$root.dialogComponent.openMediaDialog(input.CRMWhatsappMediaCatalogMediaFile, input.CRMWhatsappMediaCatalogMediaFileName, input.CRMWhatsappMediaCatalogMediaExtension);"
                  :src="input.CRMWhatsappMediaCatalogMediaFile" 
                  style="width: auto; height: auto; max-width: 100%; max-height: 100%; object-fit: contain; cursor: pointer;"
                  alt="Contenido multimedia"
                />
              </div>
              <div v-if="input.CRMWhatsappMediaCatalogMediaExtension == 'mp4'" :style="{ height: navigation.whatsappMediaCatalogMediaDialogInputContainerHeight + 'px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
                <video 
                  @click="$root.dialogComponent.openMediaDialog(input.CRMWhatsappMediaCatalogMediaFile, input.CRMWhatsappMediaCatalogMediaFileName, input.CRMWhatsappMediaCatalogMediaExtension);"
                  :src="input.CRMWhatsappMediaCatalogMediaFile"
                  style="width: auto; height: auto; max-width: 100%; max-height: 100%; object-fit: contain; cursor: pointer;"
                  controls
                  autoplay
                  loop
                  alt="Contenido multimedia"
                ></video>
              </div>
              <div v-if="input.CRMWhatsappMediaCatalogMediaExtension == 'pdf'" :style="{ height: navigation.whatsappMediaCatalogMediaDialogInputContainerHeight + 'px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
                <iframe
                  :src="input.CRMWhatsappMediaCatalogMediaFile"
                  style="width: 100%; height: 100%; border: none;"
                  title="Contenido PDF"
                ></iframe>
              </div>
            </div>
          </div>
          <br>
          <v-tooltip :disabled="validateInputForCRMWhatsappMediaCatalogMedia(false).success" location="top"> 
            <template v-slot:activator="{ props }">
              <div v-bind="props">
                <v-btn @click="navigation.insertCRMWhatsappMediaCatalogMedia ? insertCRMWhatsappMediaCatalogMedia() : updateCRMWhatsappMediaCatalogMedia()" :disabled="!validateInputForCRMWhatsappMediaCatalogMedia(false).success" :color="navigation.insertCRMWhatsappMediaCatalogMedia ? 'success' : 'warning'" dark block height="38" style="margin-bottom: 10px; margin-top: 15px;">
                  <h3>{{ navigation.insertCRMWhatsappMediaCatalogMedia ? 'AGREGAR' : 'ACTUALIZAR' }} CONTENIDO MULTIMEDIA</h3>
                  <v-icon style="margin-left: 10px;" dark right>{{ navigation.insertCRMWhatsappMediaCatalogMedia ? 'mdi-plus-circle' : 'mdi-update' }}</v-icon>
                </v-btn>
              </div>
            </template>
            <span style="max-width: 400px; display: block;">{{ validateInputForCRMWhatsappMediaCatalogMedia(false).result }}</span>
          </v-tooltip>
          <v-btn @click="closeCRMWhatsappMediaCatalogMediaDialog()" color="error" dark block height="38">
            <h3>CANCELAR</h3>
            <v-icon style="margin-left: 10px;" dark right>mdi-close-circle</v-icon>
          </v-btn>        
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: {},

    data: () => 
    ({
      input: 
      {
        CRMWhatsappMediaCatalogMediaIsVisible: true,
        deleteCRMWhatsappMediaCatalogMediaConfirmation: false,
        CRMWhatsappMediaCatalogMediaName: null,
        CRMWhatsappMediaCatalogMediaDescription: null,
        CRMWhatsappMediaCatalogMediaCaption: null,
        CRMWhatsappMediaCatalogMediaFile: null,
        CRMWhatsappMediaCatalogMediaFileName: null,
        CRMWhatsappMediaCatalogMediaExtension: null,
        CRMWhatsappMediaCatalogMediaFileSize: null
      },
      display: {},
      navigation: 
      {
        CRMWhatsappMediaCatalog: null,
        CRMWhatsappMediaCatalogMedia: null,
        insertCRMWhatsappMediaCatalogMedia: false,
        updateCRMWhatsappMediaCatalogMedia: false,
        deleteCRMWhatsappMediaCatalogMedia: false,
        CRMWhatsappMediaCatalogMediaFileUpdate: false,
        whatsappMediaCatalogMediaDialogInputContainerHeight: 0,
        CRMWhatsappMediaCatalogMediaDialogIsVisible: false
      },
      loader: 
      {
        insertCRMWhatsappMediaCatalogMedia: false,
        updateCRMWhatsappMediaCatalogMedia: false,
        deleteCRMWhatsappMediaCatalogMedia: false
      },
      interval: 
      {
        whatsappMediaCatalogMediaDialogInputContainerHeightInterval: null
      },
      systemInformation: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    watch: {},

    methods:
    {
      async insertCRMWhatsappMediaCatalogMedia(){
        if (this.validateInputForCRMWhatsappMediaCatalogMedia(true).success){
          this.loader.insertCRMWhatsappMediaCatalogMedia = true;
          const insertCRMWhatsappMediaCatalogMediaRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformation.CRMAccountID,
              'CRMAgentID': this.systemInformation.CRMAgent.CRMAgentID
            },
            'CRMWhatsappMediaCatalogMediaCRMWhatsappMediaCatalogID': this.navigation.CRMWhatsappMediaCatalog.CRMWhatsappMediaCatalogID,
            'CRMWhatsappMediaCatalogMediaName': this.input.CRMWhatsappMediaCatalogMediaName,
            'CRMWhatsappMediaCatalogMediaDescription': this.input.CRMWhatsappMediaCatalogMediaDescription,
            'CRMWhatsappMediaCatalogMediaFile': this.input.CRMWhatsappMediaCatalogMediaFile,
            'CRMWhatsappMediaCatalogMediaFileName': this.input.CRMWhatsappMediaCatalogMediaFileName,
            'CRMWhatsappMediaCatalogMediaExtension': this.input.CRMWhatsappMediaCatalogMediaExtension,
            'CRMWhatsappMediaCatalogMediaCaption': this.input.CRMWhatsappMediaCatalogMediaCaption,
            'CRMWhatsappMediaCatalogMediaIsVisible': this.input.CRMWhatsappMediaCatalogMediaIsVisible
          };
          const insertCRMWhatsappMediaCatalogMediaResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMediaCatalog/functions/insertCRMWhatsappMediaCatalogMedia', insertCRMWhatsappMediaCatalogMediaRequestQuery);
          if (insertCRMWhatsappMediaCatalogMediaResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappMediaCatalogMedia_success', 'success', 'Se ha agregado el contenido multimedia exitosamente', null, true);
            this.closeCRMWhatsappMediaCatalogMediaDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappMediaCatalogMedia_error', 'error', 'Ha ocurrido un error inesperado al agregar el contenido multimeda, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
          this.loader.insertCRMWhatsappMediaCatalogMedia = false;
        }
      },

      async updateCRMWhatsappMediaCatalogMedia(){
        if (this.validateInputForCRMWhatsappMediaCatalogMedia(true).success){
          this.loader.updateCRMWhatsappMediaCatalogMedia = true;
          const updateCRMWhatsappMediaCatalogMediaRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformation.CRMAccountID,
              'CRMAgentID': this.systemInformation.CRMAgent.CRMAgentID
            },
            'CRMWhatsappMediaCatalogID': this.navigation.CRMWhatsappMediaCatalog.CRMWhatsappMediaCatalogID,
            'CRMWhatsappMediaCatalogMediaID': this.navigation.CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaID,
            'CRMWhatsappMediaCatalogMediaName': this.input.CRMWhatsappMediaCatalogMediaName,
            'CRMWhatsappMediaCatalogMediaDescription': this.input.CRMWhatsappMediaCatalogMediaDescription,
            'CRMWhatsappMediaCatalogMediaFileUpdate': this.navigation.CRMWhatsappMediaCatalogMediaFileUpdate,
            'CRMWhatsappMediaCatalogMediaFile': this.input.CRMWhatsappMediaCatalogMediaFile,
            'CRMWhatsappMediaCatalogMediaFileName': this.input.CRMWhatsappMediaCatalogMediaFileName,
            'CRMWhatsappMediaCatalogMediaExtension': this.input.CRMWhatsappMediaCatalogMediaExtension,
            'CRMWhatsappMediaCatalogMediaCaption': this.input.CRMWhatsappMediaCatalogMediaCaption,
            'CRMWhatsappMediaCatalogMediaIsVisible': this.input.CRMWhatsappMediaCatalogMediaIsVisible
          };
          const updateCRMWhatsappMediaCatalogMediaResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMediaCatalog/functions/updateCRMWhatsappMediaCatalogMedia', updateCRMWhatsappMediaCatalogMediaRequestQuery);
          if (updateCRMWhatsappMediaCatalogMediaResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappMediaCatalogMedia_success', 'success', 'Se ha actualizado el contenido multimedia exitosamente', null, true);
            this.closeCRMWhatsappMediaCatalogMediaDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappMediaCatalogMedia_error', 'error', 'Ha ocurrido un error inesperado al actualizar el contenido multimeda, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
          this.loader.updateCRMWhatsappMediaCatalogMedia = false;
        }
      },

      async deleteCRMWhatsappMediaCatalogMedia(){
        if (this.validateInputForCRMWhatsappMediaCatalogMedia(true).success){
          this.loader.deleteCRMWhatsappMediaCatalogMedia = true;
          const deleteCRMWhatsappMediaCatalogMediaRequestQuery = 
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformation.CRMAccountID,
              'CRMAgentID': this.systemInformation.CRMAgent.CRMAgentID,
            },
            'CRMWhatsappMediaCatalogID': this.navigation.CRMWhatsappMediaCatalog.CRMWhatsappMediaCatalogID,
            'CRMWhatsappMediaCatalogMediaID': this.navigation.CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaID
          };
          const deleteCRMWhatsappMediaCatalogMediaResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMediaCatalog/functions/deleteCRMWhatsappMediaCatalogMedia', deleteCRMWhatsappMediaCatalogMediaRequestQuery);
          if (deleteCRMWhatsappMediaCatalogMediaResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappMediaCatalogMedia_success', 'success', 'Se ha eliminado el contenido multimedia exitosamente', null, true);
            this.closeCRMWhatsappMediaCatalogMediaDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappMediaCatalogMedia_error', 'error', 'Ha ocurrido un error inesperado al eliminar el contenido multimedia, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          } 
          this.loader.deleteCRMWhatsappMediaCatalogMedia = false;
        }
      },

      validateInputForCRMWhatsappMediaCatalogMedia(showSystemNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.navigation.deleteCRMWhatsappMediaCatalogMedia){
          return {success: true, result: null};
        } else if (this.input.CRMWhatsappMediaCatalogMediaName == null || !regularExpressionChecker.test(this.input.CRMWhatsappMediaCatalogMediaName)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappMediaCatalogMedia_CRMWhatsappMediaCatalogMediaName', 'warning', 'El nombre del contenido multimedia es obligatorio', null, true);
          return {success: false, result: 'El nombre del contenido multimedia es obligatorio'};
        } else if (this.input.CRMWhatsappMediaCatalogMediaName.length > 30){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappMediaCatalogMedia_CRMWhatsappMediaCatalogMediaName', 'warning', 'El nombre del contenido multimedia no puede exceder los 30 caracteres de longitud', null, true);
          return {success: false, result: 'El nombre del contenido multimedia no puede exceder los 30 caracteres de longitud'};
        } else if (this.input.CRMWhatsappMediaCatalogMediaDescription != null && this.input.CRMWhatsappMediaCatalogMediaDescription.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappMediaCatalogMedia_CRMWhatsappMediaCatalogMediaDescription', 'warning', 'La descripción del contenido multimedia no puede exceder los 65535 caracteres de longitud', null, true);
          return {success: false, result: 'La descripción del contenido multimedia no puede exceder los 65535 caracteres de longitud'};
        } else if (this.input.CRMWhatsappMediaCatalogMediaCaption != null && this.input.CRMWhatsappMediaCatalogMediaCaption.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappMediaCatalogMedia_CRMWhatsappMediaCatalogMediaCaption', 'warning', 'El caption del contenido multimedia no puede exceder los 65535 caracteres de longitud', null, true);
          return {success: false, result: 'El caption del contenido multimedia no puede exceder los 65535 caracteres de longitud'};
        } else if (this.input.CRMWhatsappMediaCatalogMediaFile != null && this.input.CRMWhatsappMediaCatalogMediaFileName != null && this.input.CRMWhatsappMediaCatalogMediaExtension != null){
          if (this.input.CRMWhatsappMediaCatalogMediaFileName.length > 100){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappMediaCatalogMedia_CRMWhatsappMediaCatalogMediaFileName', 'warning', 'El nombre del archivo del contenido multimedia no puede exceder los 100 caracteres de longitud', null, true);
            return {success: false, result: 'El nombre del archivo del contenido multimedia no puede exceder los 100 caracteres de longitud'};
          } else if (this.input.CRMWhatsappMediaCatalogMediaFileSize > 15728640){
            if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappMediaCatalogMedia_CRMWhatsappMediaCatalogMediaFileSize', 'warning', 'El tamaño del archivo multimedia no puede ser mayor a 15 MB. Si el problema persiste consulte a su administrador de sistema', null, true);
            return {success: false, result: 'El tamaño del archivo multimedia no puede ser mayor a 15 MB. Si el problema persiste consulte a su administrador de sistema'};
          }
        }
        return {success: true, result: null};
      },

      CRMWhatsappMediaCatalogMediaFileUpload(CRMWhatsappMediaCatalogMediaFileUploadEvent) {
        try {
          this.input.CRMWhatsappMediaCatalogMediaFile = null;
          this.input.CRMWhatsappMediaCatalogMediaFileName = null;
          this.input.CRMWhatsappMediaCatalogMediaExtension = null;
          this.input.CRMWhatsappMediaCatalogMediaFileSize = null;
          const CRMWhatsappMediaCatalogMediaFile = CRMWhatsappMediaCatalogMediaFileUploadEvent.target.files[0];
          if (!CRMWhatsappMediaCatalogMediaFile) return;
          const CRMWhatsappMediaCatalogMediaFileReader = new FileReader();
          CRMWhatsappMediaCatalogMediaFileReader.onload = () => {
            this.input.CRMWhatsappMediaCatalogMediaFile = CRMWhatsappMediaCatalogMediaFileReader.result;
            this.input.CRMWhatsappMediaCatalogMediaFileName = CRMWhatsappMediaCatalogMediaFile.name;
            this.input.CRMWhatsappMediaCatalogMediaFileSize = CRMWhatsappMediaCatalogMediaFile.size;
            if (CRMWhatsappMediaCatalogMediaFile.type.startsWith('image')){
              this.input.CRMWhatsappMediaCatalogMediaExtension = 'webp';
              this.navigation.CRMWhatsappMediaCatalogMediaFileUpdate = true;
            } else if (CRMWhatsappMediaCatalogMediaFile.type.startsWith('video')){
              this.input.CRMWhatsappMediaCatalogMediaExtension = 'mp4';
              this.navigation.CRMWhatsappMediaCatalogMediaFileUpdate = true
            } else if (CRMWhatsappMediaCatalogMediaFile.type.startsWith('application')){
              this.input.CRMWhatsappMediaCatalogMediaExtension = 'pdf';
              this.navigation.CRMWhatsappMediaCatalogMediaFileUpdate = true;
            } else {
              this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappMediaCatalogMediaFileUpload_error', 'error', 'El tipo del archivo multimedia debe ser imagen, video o PDF, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
              throw new Error();
            }
            if (this.input.CRMWhatsappMediaCatalogMediaFileSize > 15728640){
              this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappMediaCatalogMediaFileUpload_error', 'error', 'El tamaño del archivo multimedia no puede ser mayor a 15 MB. Si el problema persiste consulte a su administrador de sistema', null, true);
              throw new Error();
            }
          }
          CRMWhatsappMediaCatalogMediaFileReader.readAsDataURL(CRMWhatsappMediaCatalogMediaFile);
        } catch {
          this.input.CRMWhatsappMediaCatalogMediaFile = null;
          this.input.CRMWhatsappMediaCatalogMediaFileName = null;
          this.input.CRMWhatsappMediaCatalogMediaExtension = null;
          this.input.CRMWhatsappMediaCatalogMediaFileSize = null;
        }
      },
    
      async getSystemInformation(){
        try { 
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformation.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformation.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformation.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformation.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformation.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformationData_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformationData_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },

      async openCRMWhatsappMediaCatalogMediaDialog(CRMWhatsappMediaCatalog, CRMWhatsappMediaCatalogMedia, insertCRMWhatsappMediaCatalogMedia, updateCRMWhatsappMediaCatalogMedia, deleteCRMWhatsappMediaCatalogMedia){
        await this.getSystemInformation();
        this.navigation.CRMWhatsappMediaCatalog = CRMWhatsappMediaCatalog;
        this.navigation.CRMWhatsappMediaCatalogMedia = CRMWhatsappMediaCatalogMedia;
        this.navigation.insertCRMWhatsappMediaCatalogMedia = insertCRMWhatsappMediaCatalogMedia;
        this.navigation.updateCRMWhatsappMediaCatalogMedia = updateCRMWhatsappMediaCatalogMedia;
        this.navigation.deleteCRMWhatsappMediaCatalogMedia = deleteCRMWhatsappMediaCatalogMedia;
        this.navigation.CRMWhatsappMediaCatalogMediaFileUpdate = false;
        this.input.CRMWhatsappMediaCatalogMediaIsVisible = this.navigation.CRMWhatsappMediaCatalogMedia ? this.navigation.CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaIsVisible == 1 : true;
        this.input.deleteCRMWhatsappMediaCatalogMediaConfirmation = false;
        this.input.CRMWhatsappMediaCatalogMediaName = this.navigation.CRMWhatsappMediaCatalogMedia ? this.navigation.CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaName : null;
        this.input.CRMWhatsappMediaCatalogMediaDescription = this.navigation.CRMWhatsappMediaCatalogMedia ? this.navigation.CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaDescription : null;
        this.input.CRMWhatsappMediaCatalogMediaCaption = this.navigation.CRMWhatsappMediaCatalogMedia ? this.navigation.CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaCaption : null;
        this.input.CRMWhatsappMediaCatalogMediaFile = this.navigation.CRMWhatsappMediaCatalogMedia ? this.navigation.CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaURL : null;
        this.input.CRMWhatsappMediaCatalogMediaFileName = this.navigation.CRMWhatsappMediaCatalogMedia ? `${this.navigation.CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaName}.${this.navigation.CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaExtension}` : null;
        this.input.CRMWhatsappMediaCatalogMediaExtension = this.navigation.CRMWhatsappMediaCatalogMedia ? this.navigation.CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaExtension : null;
        this.input.CRMWhatsappMediaCatalogMediaFileSize = this.navigation.CRMWhatsappMediaCatalogMedia ? 1 : null;
        this.loader.insertCRMWhatsappMediaCatalogMedia = false;
        this.loader.updateCRMWhatsappMediaCatalogMedia = false;
        this.loader.deleteCRMWhatsappMediaCatalogMedia = false;
        this.navigation.CRMWhatsappMediaCatalogMediaDialogIsVisible = true;
        if (this.interval.whatsappMediaCatalogMediaDialogInputContainerHeightInterval ){
          clearInterval(this.interval.whatsappMediaCatalogMediaDialogInputContainerHeightInterval);
          this.interval.whatsappMediaCatalogMediaDialogInputContainerHeightInterval = null;
        }
        if (this.navigation.CRMWhatsappMediaCatalogMediaDialogIsVisible){
          this.interval.whatsappMediaCatalogMediaDialogInputContainerHeightInterval = setInterval(() => {
            this.navigation.whatsappMediaCatalogMediaDialogInputContainerHeight = this.$refs.CRMWhatsappMediaCatalogMediaDialogInputContainer ? this.$refs.CRMWhatsappMediaCatalogMediaDialogInputContainer.offsetHeight : 0;
          }, 100);
        }
        this.$generalFunctions.default.focusInput(this, 'CRMWhatsappMediaCatalogMediaName');
      },

      closeCRMWhatsappMediaCatalogMediaDialog(){
        this.navigation.CRMWhatsappMediaCatalogMediaDialogIsVisible = false;
        if (this.interval.whatsappMediaCatalogMediaDialogInputContainerHeightInterval){
          clearInterval(this.interval.whatsappMediaCatalogMediaDialogInputContainerHeightInterval);
          this.interval.whatsappMediaCatalogMediaDialogInputContainerHeightInterval = null;
        }
        this.$emit('closeCRMWhatsappMediaCatalogMediaDialog');
      }
    },
  }
</script>